'use strict';

export const apiBaseUrl = "https://api.themoviedb.org/3/";
export const imageBaseUrl = "https://image.tmdb.org/t/p/";
export const apiKey = "fa95cddfa25a27f18e30bbdbd383054b";

